import { render, staticRenderFns } from "./document-unique.html?vue&type=template&id=d8718d52&scoped=true&external"
import script from "./document-unique.js?vue&type=script&lang=js&external"
export * from "./document-unique.js?vue&type=script&lang=js&external"
import style0 from "./document-unique.scss?vue&type=style&index=0&id=d8718d52&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8718d52",
  null
  
)

export default component.exports